export default {
  files: process.env.API_FILES_URL,
  url: process.env.API_URL
}



// WEBPACK FOOTER //
// ./src/api.js